import {
    Typography,
} from "@mui/material";

import { IconTrash, IconPlus } from '@tabler/icons-react';
import { PriceSettingsContainer } from '../../../Styles/Maintenance/priceSettingsStyles';

import { ModulePrice, PriceSettingsInterface } from '../../../Models/Maintenance/PriceSettings/PriceSettings';

import AccessibilityHelper from '../../../Utilities/Helpers/AccessibilityHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { PriceSettingsField } from '../../../Utilities/Enums/ParametersEnum';
import { AdminModules } from '../../../Utilities/Enums/AdminModulesEnum';
import { CurrencyEnum } from '../../../Utilities/Enums/CurrencyEnums';

import CustomButton from '../../../CustomViews/Elements/CustomButton';
import CustomIconButton from '../../../CustomViews/Elements/CustomIconButton';
import ModulesSettingsDropdown from '../../../CustomViews/Elements/AutoComplete/ModulesSettingsDropdown';
import FormTextField from '../../../CustomViews/Elements/FormTextField';

export default function ModulePricesSettings(props: PriceSettingsInterface) {
    //Variables
    let { formData, setformData, errorMessages, setopenDelete, settoDeleteItem, setdeleteType, moduleTempId, setmoduleTempId, modulesCount, setmodulesCount, priceSettingsTab, selectedPriceSettingsTab } = props;
    let moduleProps: any = [];
    let moduleBasePriceInRmProps: any = [];
    let currency = priceSettingsTab?.find((item: any) => item.id == selectedPriceSettingsTab)?.currencyCode ?? "RM";
    currency = (currency != CurrencyEnum.MYR ? currency : 'RM');

    if(modulesCount > 0) {
        formData?.[PriceSettingsField.MODULES]?.forEach((moduleItem: any, mIndex: any) => {
            moduleProps.push({
                name: PriceSettingsField.MODULE_PUBLIC_ID + moduleItem?.tempId,
                title: 'Module Name',
                fieldValue: moduleItem?.[PriceSettingsField.MODULE_PUBLIC_ID] ?? "",
                fieldClassName: 'moduleDropdown',
                hideLabel: true,
                disabled: !AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_EDIT),
                // required: requiredFields?.find((field: any) => field.keyName == PriceSettingsField.PUBLIC_ID)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _modules: ModulePrice[]  = formData?.[PriceSettingsField.MODULES] ?? [];

                    _modules[mIndex] = {
                        ..._modules[mIndex],
                        [PriceSettingsField.MODULE_PUBLIC_ID]: selectedValue?.id ?? "",
                        [PriceSettingsField.MODULE_NAME]: selectedValue?.name ?? "",
                    };

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.MODULES]: _modules }));
                    }
                },
            });

            moduleBasePriceInRmProps.push({
                name: PriceSettingsField.MODULE_BASE_PRICE + moduleItem?.tempId,
                title: 'Base Price (' + currency + ')',
                fieldValue: moduleItem?.[PriceSettingsField.MODULE_BASE_PRICE] ?? "",
                hideLabel: true,
                type: 'number',
                disabled: !AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_EDIT),
                // required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _modules: ModulePrice[]  = formData?.[PriceSettingsField.MODULES] ?? [];

                    _modules[mIndex] = {
                        ..._modules[mIndex],
                        [PriceSettingsField.MODULE_BASE_PRICE]: selectedValue ?? ""
                    };

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.MODULES]: _modules }));
                    }
                },
            });
        }); 
    }

    //Event Handlers
    
    //Rendering Functions
    return <PriceSettingsContainer>
        <Typography className="settingItemFieldHeader span2Item">Module Name</Typography>
        <Typography className="settingItemFieldHeader span2Item">Base Price ({currency}) / Monthly</Typography>

        {formData?.[PriceSettingsField.MODULES]?.map((mod: any, moduleIndex: number) => (<>
            <ModulesSettingsDropdown {...moduleProps[moduleIndex]} />
            <FormTextField {...moduleBasePriceInRmProps[moduleIndex]} />
            {AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_DELETE) ? <CustomIconButton toolTipName='Delete'
                icon={<IconTrash color='var(--buttonHoverBGDangerColor)' />}
                onClick={(e: any) => {
                    if(setopenDelete) {
                        setopenDelete(true);
                    }

                    if(settoDeleteItem) {
                        settoDeleteItem({ index: moduleIndex, name: mod?.[PriceSettingsField.MODULE_NAME] ?? "" });
                    }
                    
                    if(setdeleteType) {
                        setdeleteType('modulePrice');
                    }
                }} /> : <div />}
        </>))}

        {AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_CREATE) && <CustomButton
            btnType={ButtonType.CANCEL}
            title='Add Module'
            startIcon={<IconPlus />}
            // isRoundedCorner={true}
            onClick={(e: any) => {
                let _modules: ModulePrice[]  = formData?.[PriceSettingsField.MODULES] ?? [];
                let _moduleTempId = (moduleTempId ?? 0) + 1;

                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [PriceSettingsField.MODULES]: [
                            ..._modules,
                            {
                                ...new ModulePrice(),
                                tempId: _moduleTempId,
                            }
                        ]
                    }));
                }

                if(setmoduleTempId) {
                    setmoduleTempId(_moduleTempId);
                }

                if(setmodulesCount) {
                    setmodulesCount((modulesCount ?? 0) + 1);
                }
            }} />}
    </PriceSettingsContainer>
}